
























import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';

import AMXButton from '~/components/AMXButton.vue';
import ValidationErrorMessage from '~/components/ValidationErrorMessage.vue';

interface Validation {
  vin: string | null;
}

interface VehiclesVINSearchFormEmitProps {
  emit: {
    (event: 'submit', vin: string): void;
  };
}

export default defineComponent({
  components: {
    UCIcon,
    AMXButton,
    ValidationErrorMessage,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    validationError: {
      type: String,
      default: null,
    },
  },
  setup(_: unknown, { emit }: VehiclesVINSearchFormEmitProps) {
    const inputVIN = ref('');
    const validation = ref<Validation>({
      vin: null,
    });

    const handleInput = (e: Event) => {
      inputVIN.value = (e.target as HTMLInputElement).value.replace(/[^a-z\d]/gi, '');
    };

    const handleSubmit = () => {
      if (!inputVIN.value) {
        validation.value.vin = 'Please enter your VIN';
        return;
      }
      if (inputVIN.value.length !== 17) {
        validation.value.vin = `Please enter a valid VIN. Must be 17 characters long`;
        return;
      }

      emit('submit', inputVIN.value);
    };

    watch(inputVIN, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        validation.value.vin = null;
      }
    });

    return {
      inputVIN,
      validation,
      handleInput,
      handleSubmit,
    };
  },
});
